import {
  Component,
  inject,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { ActivatedRoute, Router, NavigationStart } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import {
  UserLoginDTO,
  UserLoginReadByUserIdRequestDTO,
  UserLoginUpdateRequestDTO,
} from "src/app/login/userlogin.interface";
import { UserLoginService } from "src/app/login/userlogin.service";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.css"],
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  userId!: number;
  userData!: UserLoginDTO;
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private userLoginService = inject(UserLoginService);
  private toastr = inject(ToastrService);
  private routerSub!: Subscription;

  newPassword = "";
  confirmPassword = "";

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.userId = Number(params.get("id"));
      if (this.userId) {
        this.getUserLogin();
      }
    });

    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        localStorage.removeItem("access_token");
      }
    });

    this.toastr.warning(
      "Your password has expired. Please set a new password.",
      "Password Expired"
    );
  }

  ngOnDestroy(): void {
    localStorage.removeItem("access_token");

    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  getUserLogin() {
    let data: UserLoginReadByUserIdRequestDTO = {
      userId: this.userId,
    };

    this.userLoginService.UserLogin_ReadByUserId(data).subscribe((res) => {
      this.userData = res;

      if (res.status !== "Expired") {
        this.router.navigate(["/"]);
      }
    });
  }

  updatePassword() {
    if (!this.newPassword || !this.confirmPassword) return;

    if (this.newPassword !== this.confirmPassword) {
      this.toastr.error(
        "Your new password and confirmation do not match. Please check and try again.",
        "Password Mismatch"
      );
      return;
    }

    let data: UserLoginUpdateRequestDTO = {
      loginId: this.userData.loginId,
      userId: this.userData.userId,
      userName: this.userData.userName,
      userPassword: this.newPassword,
      isActive: 1,
      status: "Active",
      actionUser: this.userData.userId.toString(),
    };

    this.userLoginService.UserLogin_Update(data).subscribe(() => {
      this.toastr.success(
        "Please login with your new password.",
        "Your password has been changed successfully!"
      );

      localStorage.removeItem("access_token");

      setTimeout(() => {
        this.router.navigate(["/login"]);
      }, 2000);
    });
  }
  

  redirectToSignUp() {
    localStorage.removeItem("access_token");
    this.router.navigate(["/signup"]);
  }
}